export default __webpack_public_path__ + "static/media/No_Image.d8d76425.jpg";